const MAC = 'Mac'

export default {
  MAC,
}
